// extracted by mini-css-extract-plugin
export default {"markerMenuOverlay":"roadmap-marker-menu-module__markerMenuOverlay--uskmr"};